import {
  Button,
  Card,
  Paper,
  Radio,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import HeadingWithDescription from "../../components/headingWithDescription";
import { toast } from "react-toastify";
import ActivityIndicator from "../../components/activityIndicator";
import { AppointmentResponse } from "../../types/appointment";
import AppointmentServices from "../../services/appointment.services";
import { CheckCircle } from "@mui/icons-material";

const SLOTS = [
  {
    slotName: "9:00 AM - 01:00 PM",
    slotCode: "01",
  },
  {
    slotName: "01:00 PM - 05:00 PM",
    slotCode: "02",
  },
  {
    slotName: "05:00 PM - 08:00 PM",
    slotCode: "03",
  },
];

function SingleRow({
  title,
  value,
  shouldHighlight = false,
}: {
  title: string | undefined;
  value: string | undefined;
  shouldHighlight?: boolean;
}) {
  return (
    <TableRow>
      <TableCell>{title}</TableCell>
      <TableCell
        sx={{ fontWeight: shouldHighlight ? "600" : "400" }}
        align="right"
      >
        {value}
      </TableCell>
    </TableRow>
  );
}

function FeedBackForm({
  appointmentDetails,
  loading,
  handleFeedback,
  message,
}: {
  appointmentDetails: AppointmentResponse | null;
  loading: boolean;
  handleFeedback: any;
  message: string;
}) {
  const [selectedresponse, setSelectedResponse] = useState("");
  const [selectedReason, setSelectedReason] = useState("");

  return (
    <>
      {loading && <ActivityIndicator />}
      <Stack p={2} bgcolor={"#f7f7f7"} flex={1} gap={2}>
        <HeadingWithDescription
          heading="Technician Visit Confirmation"
          description="Please give your valuable feedback"
        />
        {appointmentDetails && (
          <TableContainer sx={{ bgcolor: "white" }} component={Paper}>
            <Table>
              <TableBody>
                <SingleRow
                  title="Ticket ID"
                  value={appointmentDetails?.ticket_id}
                  shouldHighlight
                />
                <SingleRow
                  title="Mobile"
                  value={appointmentDetails?.mobile as any}
                />
                <SingleRow
                  title="Date"
                  value={appointmentDetails?.appointment_date}
                />
                <SingleRow
                  title="Slot"
                  value={
                    SLOTS.find(
                      (s) => s.slotCode === appointmentDetails?.appointment_slot
                    )?.slotName ?? SLOTS[0].slotName
                  }
                />
              </TableBody>
            </Table>
          </TableContainer>
        )}
        {!message?.length ? (
          <>
            {/* Select Response*/}
            <Card>
              <Stack p={2}>
                <Typography>1. Did the technician visited?</Typography>
                <div
                  className="flex gap-1 items-center cursor-pointer"
                  onClick={() => setSelectedResponse("1")}
                >
                  <Radio
                    size="small"
                    sx={{ alignSelf: "flex-start" }}
                    checked={selectedresponse === "1"}
                    name="response"
                    inputProps={{ "aria-label": "A" }}
                  />
                  <Typography variant="body2">Yes, Visit done</Typography>
                </div>
                <div
                  className="flex gap-1 items-center"
                  onClick={() => setSelectedResponse("0")}
                >
                  <Radio
                    size="small"
                    sx={{ alignSelf: "flex-start" }}
                    checked={selectedresponse === "0"}
                    name="response"
                    inputProps={{ "aria-label": "A" }}
                  />
                  <Typography variant="body2">No, Visit pending</Typography>
                </div>
              </Stack>
            </Card>

            {/* Select Reason*/}
            {selectedresponse === "1" && (
              <Card>
                <Stack p={2}>
                  <Typography>2. Is the issue resolved?</Typography>
                  <div
                    className="flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedReason("1")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "1"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">Resolved</Typography>
                  </div>
                  <div
                    className="flex gap-1 items-center"
                    onClick={() => setSelectedReason("2")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "2"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">Not Resolved</Typography>
                  </div>
                </Stack>
              </Card>
            )}

            {/* Select Reason*/}
            {selectedresponse === "0" && (
              <Card>
                <Stack p={2}>
                  <Typography>2. Select a reason.</Typography>
                  <div
                    className="flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedReason("1")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "1"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">
                      Technician not visited
                    </Typography>
                  </div>
                  <div
                    className="flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedReason("2")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "2"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">
                      Technician not called
                    </Typography>
                  </div>
                  <div
                    className="flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedReason("3")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "3"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">Spare pending</Typography>
                  </div>
                  <div
                    className="flex gap-1 items-center cursor-pointer"
                    onClick={() => setSelectedReason("4")}
                  >
                    <Radio
                      size="small"
                      sx={{ alignSelf: "flex-start" }}
                      checked={selectedReason === "4"}
                      name="response"
                      inputProps={{ "aria-label": "A" }}
                    />
                    <Typography variant="body2">
                      Technician not visited
                    </Typography>
                  </div>
                </Stack>
              </Card>
            )}
            <Button
              onClick={() => {
                handleFeedback(selectedresponse, selectedReason);
              }}
              disabled={selectedReason === "" || selectedresponse === ""}
              sx={{ bgcolor: "black" }}
              size="large"
              variant="contained"
            >
              Submit Feedback
            </Button>
          </>
        ) : (
          <Card variant="outlined">
            <Stack direction={"row"} p={2} gap={1} alignItems={"center"}>
              <CheckCircle color="success" />
              <Typography variant="body2">{message}</Typography>
            </Stack>
          </Card>
        )}
      </Stack>
    </>
  );
}

export default function CheckAppointment() {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const appointmentNumber = searchParams.get("id");
  const [appointmentDetails, setAppointmentDetails] =
    useState<AppointmentResponse | null>(null);
  const [message, setMessage] = useState("");

  const getAppointmentDetails = async (appointmentNumber: string) => {
    try {
      const res = await AppointmentServices.getAppointmentDetails(
        appointmentNumber
      );
      if (res) {
        setAppointmentDetails(res);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleFeedback = async (response: string, reason: string) => {
    setLoading(true);
    try {
      if (appointmentDetails) {
        const res = await AppointmentServices.feedbackAppointment(
          appointmentDetails?.ticket_id,
          response,
          reason
        );
        if (res) {
          toast.success("Feedback submitted");
          setMessage("Thanks for your valuable feedback.");
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (appointmentNumber) {
      getAppointmentDetails(appointmentNumber);
    }
    // eslint-disable-next-line
  }, [appointmentNumber]);

  if (!appointmentNumber) return <Navigate to="/" />;

  return (
    <FeedBackForm
      handleFeedback={handleFeedback}
      appointmentDetails={appointmentDetails}
      loading={loading}
      message={message}
    />
  );
}
